import { createCustomEnum } from "./customEnum";

const PriorityTypes = createCustomEnum({
	Default: {
		value: 0,
		name: "default",
		displayName: "Default",
	},
	Priority: {
		value: 1,
		name: "priority",
		displayName: "Priority",
	},
	Diamond: {
		value: 2,
		name: "diamond",
		displayName: "Diamond",
	},
	RedDiamond: {
		value: 3,
		name: "red_diamond",
		displayName: "Red Diamond",
	},
});

export default PriorityTypes;
